export const constant = {
  languageCodes: {
    en: 1,
    ar: 2,
    fr: 3,
    it: 25,
    de: 26,
    es: 27,
    ur: 28,
  },
  color: {
    DODGER_BLUE: "#339CFF",
    WHITE: "#FFFFFF",
  },
  IMAGE_EXTENSION: [
    ".jpg", // JPEG images
    ".jpeg", // JPEG images
    ".png", // PNG images
    ".gif", // GIF images
    ".bmp", // Bitmap images
    ".tiff", // TIFF images
    ".tif", // TIFF images
    ".webp", // WebP images
    ".ico", // Icon images
    ".svg", // Scalable Vector Graphics
    ".heic", // High-Efficiency Image File Format
    ".heif", // High-Efficiency Image Format
    ".raw", // RAW image files (general)
    ".cr2", // Canon RAW
    ".nef", // Nikon RAW
    ".arw", // Sony RAW
    ".orf", // Olympus RAW
    ".rw2", // Panasonic RAW
    ".psd", // Photoshop files
  ],
};
